/* eslint-disable simple-import-sort/imports */
import "../../components/welcomeScreen/welcome.scss";
import PropTypes from "prop-types";
import { isString } from "lodash";

import React from "react";
import { connect } from "react-redux";
// import PropTypes from "prop-types";
import { parseString } from "xml2js";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import PubSub from "pubsub-js";
import PubSubTopics from "../../constants/pubSubTopics";
import WelcomeTipsListView from "../../components/welcomeScreen/WelcomeTipsListView";
import WelcomeSamplesListView from "../../components/welcomeScreen/WelcomeSamplesListView";
import FormButton from "../../components/form/FormButton";

import openSampleTimeline from "../../utils/openSampleTimeline";
import samples from "../../testInBrowser/samplesArray";
import selectors from "./selectors";
import { onOpenMurderOnTheOrientExpress } from "../../utils/licenseMessages";

const tips = [
  {
    name: "Knowledge Base",
    icon: "book",
    fullPath: "https://help.timeline.app"
  },
  {
    name: "Support",
    icon: "comments",
    fullPath: "https://timeline.app/support"
  },
  {
    name: "Feature Requests",
    icon: "star",
    fullPath: "https://timeline.app/feature-requests/"
  }
];

const openLink = path => {
  PubSub.publish(PubSubTopics.sendNativeMessage, {
    msg: nativeCommsBroadcastMessageTypes.OPEN_EXTERNAL_LINK,
    path
  });
};

class WelcomeRightContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      blogPosts: null
    };

    this.retrieveWebsiteUpdatesResponse = this.retrieveWebsiteUpdatesResponse.bind(this);
    this.onExampleClick = this.onExampleClick.bind(this);
  }

  componentDidMount() {
    this._pubSubScrollToItemToken = PubSub.subscribe(
      PubSubTopics.websiteUpdatesResponse,
      this.retrieveWebsiteUpdatesResponse
    );
    this.retrieveWebsiteUpdates();
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubScrollToItemToken);
  }

  onExampleClick(exampleName) {
    if (isNativeCommsInstalled()) {
      onOpenMurderOnTheOrientExpress(exampleName);
      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.WELCOME_OPEN_EXAMPLE_FILE,
        exampleName
      });
    } else {
      openSampleTimeline(exampleName);
    }
  }

  retrieveWebsiteUpdates() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.RETRIEVE_WEBSITE_UPDATES
    });
  }

  retrieveWebsiteUpdatesResponse(msg, data) {
    let blogPosts;
    parseString(data.response, function (err, result) {
      try {
        blogPosts = [];
        let items = result.rss.channel[0].item;
        items = items.slice(0, 2);
        items.map((item, i) => {
          const itemDate = new Date(item.pubDate);
          const itemDescription = typeof item.description === "object" ? item.description[0] : item.description;
          const itemContent = itemDescription.replace(/(<([^>]+)>)/gi, "");
          let itemLink = isString(item.link) ? item.link : null;
          if (!itemLink && Array.isArray(item.link) && item.link.length > 0) {
            itemLink = item.link[0];
          }
          blogPosts.push(
            <div key={i}>
              <div className="welcomeDate">{itemDate.toDateString()}</div>
              <div className="welcomeFeature">
                <p>
                  <b>{item.title}</b>
                </p>
                <p>{itemContent}</p>
                {itemLink ? (
                  <FormButton
                    label="Read more"
                    linkStyle={true}
                    onClick={() => {
                      openLink(itemLink);
                    }}
                  />
                ) : null}
              </div>
            </div>
          );
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    });

    this.setState({ blogPosts: blogPosts });
  }

  render() {
    const linksRow = (
      <div className="row">
        <h2>Links</h2>
        {/* Rename to Learn when we have tips */}
        <WelcomeTipsListView tipList={tips} />
      </div>
    );
    return (
      <div className="welcomeRightContainer">
        <div className="welcomeRightScrollContainer">
          <div className="welcomeRightFlexContainer">
            <div>
              <div className="row welcomeRow">
                <h1>Welcome to Aeon Timeline</h1>
                <p>The timeline tool for creative writing, project &amp; case management.</p>
              </div>
              <div className="row">
                <div className="col colLists">
                  <div className="row">
                    <h2>Explore</h2>
                    <WelcomeSamplesListView sampleList={this.props.exampleFiles} onSampleClick={this.onExampleClick} />
                  </div>
                  {this.state.blogPosts ? linksRow : null}
                </div>
                {this.state.blogPosts ? (
                  <div className="col">
                    <div className="row">
                      <h2>Latest Updates</h2>
                      {this.state.blogPosts}
                    </div>
                  </div>
                ) : (
                  <div className="col">{linksRow}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let exampleFiles = samples;
  if (isNativeCommsInstalled()) {
    exampleFiles = selectors.getSamplesForRightPanel(state.present);
  }
  return {
    exampleFiles
  };
};

WelcomeRightContainer.propTypes = {
  exampleFiles: PropTypes.array.isRequired
};

export default connect(mapStateToProps, null)(WelcomeRightContainer);
